module.exports = __webpack_public_path__ + "static/img/jay-king-masthead.4a40c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/employees/jay-king-masthead.jpg
// module id = yXjZ
// module chunks = 1